import React from 'react';
import { VscAzure } from "react-icons/vsc";
import { FaAws } from "react-icons/fa";
import { SiGooglecloud } from "react-icons/si";
import { FaDigitalOcean } from "react-icons/fa";
import { SiOracle } from "react-icons/si";
import { SiTerraform } from "react-icons/si";
import { SiOpentofu } from "react-icons/si";


const AnimatedBackground = () => {
  // Logos de proveedores cloud
  const cloudProviders = [
    { name: 'AWS', icon: <FaAws style={{ color: '#FF9900' }} /> },
    { name: 'Azure', icon: <VscAzure style={{ color: '#0078D4' }} /> },
    { name: 'GCP', icon: <SiGooglecloud style={{ color: '#4285F4' }} /> },
    { name: 'DigitalOcean', icon: <FaDigitalOcean style={{ color: '#0080FF' }} /> },
    { name: 'Terraform', icon: <SiTerraform style={{ color: '#623CE4' }} /> },
    { name: 'Oracle Cloud', icon: <SiOracle style={{ color: '#F80000' }} /> },
    { name: 'OpenTofu', icon: <SiOpentofu style={{ color: '#FF6347' }} /> },
  ];

  return (
    <div className="absolute inset-0 overflow-hidden -z-10 opacity-60">
      {/* Main blobs */}
      <div className="blob-animation h-72 w-72 top-1/3 -left-24 animation-delay-2000"></div>
      <div className="blob-animation h-80 w-80 bottom-1/4 -right-24 animation-delay-4000"></div>
      <div className="blob-animation h-64 w-64 top-1/4 right-1/3 animation-delay-3000"></div>
      
      {/* Dot pattern overlay */}
      <div className="absolute inset-0 dot-pattern opacity-70"></div>
      
      {/* Grid lines */}
      <div className="absolute inset-0" 
        style={{
          backgroundImage: 'linear-gradient(to right, rgba(59, 130, 246, 0.05) 1px, transparent 1px), linear-gradient(to bottom, rgba(59, 130, 246, 0.05) 1px, transparent 1px)',
          backgroundSize: '80px 80px'
        }}>
      </div>
      
      {/* Floating cloud provider logos - bigger and distributed evenly */}
      <div className="absolute inset-0 pointer-events-none">
        {cloudProviders.map((provider, i) => {
          // Generar posiciones bien distribuidas por toda la pantalla
          const sectionWidth = 100 / cloudProviders.length;
          const left = (i * sectionWidth) + (Math.random() * (sectionWidth * 0.6));
          
          return (
            <div 
              key={i}
              className="absolute rounded-full bg-white/70 shadow-md flex items-center justify-center transition-transform duration-300 ease-in-out hover:scale-150 cursor-pointer"
              style={{
                width: `60px`,
                height: `60px`,
                top: `${Math.random() < 0.5 ? 10 + Math.random() * 30 : 60 + Math.random() * 30}%`,
                left: `${left}%`,
                animation: `floating ${7 + Math.random() * 8}s ease-in-out infinite`,
                animationDelay: `${i * 0.7}s`,
                zIndex: 5
              }}
            >
              <span className="text-4xl">{provider.icon}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AnimatedBackground; 